/**
 * Initial state factory for the "groupchannel" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. `groupChannelData` holds the
 * currently viewed channel's details, `groupChannelsList` the list of group
 * channels, and `followingList`/`followingCount` the current user's followed
 * channels and their total count.
 */
export default () => ({
  groupChannelData: {},
  groupChannelsList: [],
  followingList: [],
  followingCount: 0,
});

/**
 * Resets the following list and count to empty. Not wired up as a Vuex
 * mutation (it is a plain named export, not part of updates.js) and is
 * currently unused.
 */
export function clearFollowingList(state) {
  state.followingList = [];
  state.followingCount = 0;
}
